export default __webpack_public_path__ + "static/media/us-banner.770f2292.png";